import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver-es';
import { FinalEditSafetyComponent } from 'src/app/core/check/final-edit-safety/final-edit-safety.component';
import { EditSafetyComponent } from 'src/app/core/check/edit-safety/edit-safety.component';
import { CustomDetailComponentComponent } from 'src/app/core/check/custom-detail-component/custom-detail-component.component';
import { AetSafetyDashboardService } from 'src/app/services/aet-safety-dashboard.service';
import moment from 'moment';
import { DatePipe, formatDate } from '@angular/common';
import { CommentRendererComponent } from 'src/app/core/grid-renderer/comment.grid-renderer';
import { CellsComponent } from 'src/app/core/grid-renderer/cells/cells.component';
import { ImagePopUpComponent } from 'src/app/core/check/image-pop-up/image-pop-up.component';
import { CloseEventComponent } from 'src/app/core/check/close-event/close-event.component';
import { interval, ReplaySubject, Subscription } from 'rxjs';
import { map, startWith, takeWhile } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { ChildGridComponent } from './child-grid/child-grid.component';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Constants } from 'src/app/constants';
import { ExcelStyle, FilterChangedEvent, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { ChartDataset, ChartOptions, ChartType } from 'chart.js';
import { SafetyDashboardService } from 'src/app/services/safety-dashboard.service';
import 'ag-grid-enterprise';
import { SafetyTooltip } from 'src/app/core/grid-renderer/safety-tooltip';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-safety-dashboard',
    templateUrl: './safety-dashboard.component.html',
    styleUrls: ['./safety-dashboard.component.scss'],
    standalone: false // NOSONAR
})
export class SafetyDashboardComponent implements OnInit {
  gridApi: any;
  columnDefs = [];
  displayRowData: any;
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  successMessage;
  errorMessage;
  icons;
  isAccessible=true;
  check: any = false;
  gridOptions: any = { enableCellTextSelection: true,tooltipShowDelay: 500,detailRowAutoHeight:false};
  siteItems: any;
  public getRowStyle: any;
  selected_position_id: any = 60000;
  detailCellRendererParams;
  frameworkComponents;
  dynamicHeight: any;
  losDrpDown;
  processDrpDown;
  regionDrpDown;
  severityDrpDown;
  tmTitleDrpDown;
  vendorDrpDown;
  rowHeight = 30;
  tooltipShowDelay = 0;
  tooltipHideDelay = 9000;
  tooltipMouseTrack = true;
  rowClassRules: any;
  paginationPageSize: any = 10;
  autoPress: boolean = false;
  private intervalSubscription: Subscription;
  groupDefaultExpanded = -1;
  groupDisplayType = 'groupRows';
  // public modules = AllModules;
  childData: any;
  deleteAccessible: boolean = true;

  selectedTab:any;
  highlightSafety: any = false
  highlightKPI: any = false
  timespanlist = ['Daily', 'Weekly', 'Monthly', 'Yearly'];
  selectedSpan: string = 'Daily';
  endDateLine: any = new Date().toISOString().substring(0, 10);
  startDateLine: any;
  thirtyDaysAgo: any = new Date();
  dropdownRegionLine: any[];
  selectedRegionLine: any[] = [];
  dropdownLpLine: any[];
  selectedLpLine: any[];
  dropdownSeverityLine: any[];
  selectedSeverityLine: any[];
  event: any;
  dropdownData: any;
  initialTimeSpan: any;
  universalData: any;
  curDate : any = formatDate(new Date(),'yyyyMMdd','en');
  maxValue: number;
  detailRowHeight=60
  regionFilterCtrl: FormControl = new FormControl();
  filteredRegion: ReplaySubject<any[]> = new ReplaySubject(1);
  lpFilterCtrl: FormControl = new FormControl();
  filteredLp: ReplaySubject<any[]> = new ReplaySubject(1);
  severityFilterCtrl: FormControl = new FormControl(); const_aet = 'AET Safety Dashboard'
  filteredSeverity: ReplaySubject<any[]> = new ReplaySubject(1); const_year = 'MM/dd/yyyy'
  constructor(
     private readonly router : Router,
    public dialog: MatDialog,
     private readonly safetydashboardService :SafetyDashboardService,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    private readonly datePipe: DatePipe,
     private readonly aetSafetyDashboardService : AetSafetyDashboardService,
    private  readonly constants: Constants,
     private readonly aetStateService : AetStateService
  ) {
    this.context = {
      componentParent: this,
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0', // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0', // NOSONAR
    };
  }
  defaultColDef: any = {
    flex: 1,
    resizable: true,
  };

  onFirstDataRendered(event) {
    event.api.resetRowHeights();
  }

  ngOnInit(): void { // NOSONAR
    // this.checkRoles();
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.dynamicHeight = 0.665 * window.innerHeight;
    this.siteItems = [
      { position: '60000', description: '1 min' },
      { position: '120000', description: '2 min' },
      { position: '300000', description: '5 min' },
      { position: '600000', description: '10 min' },
    ];
    this.columnDefs = [
      {
        headerName: '',
        field: 'rightArrow',
        cellRenderer: CustomDetailComponentComponent,
        minWidth: 20,
//        autoHeight: true,
      },
      {
        headerName: 'REPORT ID',
        field: 'reportId',
        minWidth: 90,
        //maxWidth: 100,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
      },
      {
        headerName: 'TYPE',
        field: 'reportType',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 120,
        //maxWidth: 130,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
      },
      {
        headerName: 'REGION',
        field: 'region',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 90,
        //maxWidth: 100,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
      },
      {
        headerName: 'ROUTE',
        field: 'route',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 90,
        //maxWidth: 100,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
        valueGetter: function (params) {
          return params.data.route + '-' + params.data.run;
        },
      },
      {
        headerName: 'SEVERITY',
        field: 'severity',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 90,
        //maxWidth: 100,
        floatingFilter: true,
//        autoHeight: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'LP',
        field: 'logisticPointDescription',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 110,
        //maxWidth: 130,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
//        autoHeight: true,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'INCIDENT DATE/TIME',
        field: 'incidentDate',
        width: 80,
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 150,
        //maxWidth: 150,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
        comparator: this.dateComparator
      },
      {
        headerName: 'FA',
        field: 'fa',
        minWidth: 40,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'FA - FATALITY',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'AM',
        field: 'am',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'AM - AMPUTATION',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'LOH',
        field: 'loh',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip: 'LOH - LOSS OF HEARING',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'FR',
        field: 'fr',
        minWidth: 40,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'FR - FRACTURE',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'INJ',
        field: 'inj',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'INJ - INJURY',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'ILJ',
        field: 'ilj',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'ILJ - ILLNESS',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'LOS',
        field: 'los',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'LOS - LOSS OF SIGHT',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'HJ',
        field: 'hj',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'HJ - HEAD INJURY',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'HO',
        field: 'ho',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'HO - HOSPITALIZATION',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'NHT',
        field: 'nht',
        minWidth: 50,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'NHT - NEAR MISS/HIT',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'BU',
        field: 'bu',
        minWidth: 40,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'BU - BURN',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'ST',
        field: 'st',
        minWidth: 40,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'ST - STOP 6',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'PD',
        field: 'pd',
        minWidth: 40,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'PD - PROPERTY DAMAGE',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'OT',
        field: 'ot',
        minWidth: 40,
        //maxWidth: 60,
//        autoHeight: true,
        headerTooltip:'OT - OTHER',
        cellRenderer: CellsComponent,
      },
      {
        headerName: 'REPORT DATE',
        field: 'reportDate',
        floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        minWidth: 135,
        //maxWidth: 140,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
        comparator: this.dateComparator
      },
      {
        headerName: 'TRAILER',
        field: 'trailer',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 100,
        //maxWidth: 100,
        floatingFilter: true,
//        autoHeight: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'DESCRIPTION OF EVENT',
        field: 'incidentSummary',
        tooltipComponent: SafetyTooltip,
        tooltipField: 'incidentSummary',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 230,
        //maxWidth: 250,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
//        autoHeight: true,
        sortable: true,
        unSortIcon: true,
        cellStyle: { cursor: 'pointer' },
        cellRenderer: CommentRendererComponent,
      },
      {
        headerName: 'STATUS',
        field: 'status',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 120,
        //maxWidth: 120,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
      },
      {
        headerName: 'LAST UPDATED',
        field: 'lastUpdateDate',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 130,
        //maxWidth: 140,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
        comparator: this.dateComparator
      },
      {
        headerName: 'LAST UPDATED BY',
        field: 'lastUpdateBy',
        floatingFilterComponentParams: { suppressFilterButton: true },
        minWidth: 150,
        //maxWidth: 160,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        sortable: true,
        unSortIcon: true,
//        autoHeight: true,
      },
      {
        headerName: 'ACTION',
        field: 'safety_dashboard',
        minWidth: 120,
        //maxWidth: 120,
        pinned: 'right',
        cellRenderer: CustomDetailComponentComponent,

      },
    ];

    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {
            headerName: 'TM Title',
            field: 'tmTitle',
            minWidth: 100,
            //maxWidth: 100,
    //        autoHeight: true,
          },
          {
            headerName: 'Length Of service',
            field: 'lengthOfService',
            minWidth: 150,
            //maxWidth: 150,
    //        autoHeight: true,
          },
          {
            headerName: 'Process',
            field: 'process',
            width: 50,
    //        autoHeight: true,
          },
          {
            headerName: 'Cause Of Incident',
            field: 'causeOfIncident',
            minWidth: 150,
            //maxWidth: 150,
    //        autoHeight: true,
          },
          {
            headerName: 'SWF',
            field: 'swf',
            width: 30,
    //        autoHeight: true,
            cellRenderer: CellsComponent,
          },
          {
            headerName: 'SOP',
            field: 'sop',
            width: 20,
    //        autoHeight: true,
            cellRenderer: CellsComponent,
          },
          {
            headerName: 'ECG',
            field: 'ecg',
            width: 20,
    //        autoHeight: true,
            cellRenderer: CellsComponent,
          },
          {
            headerName: 'TM',
            field: 'tm',
            width: 20,
    //        autoHeight: true,
            cellRenderer: CellsComponent,
          },
          {
            headerName: 'LSA',
            field: 'lsa',
            width: 20,
    //        autoHeight: true,
            cellRenderer: CellsComponent,
          },
          {
            headerName: 'LP Initiated',
            field: 'lpCounterMeasures',
            width: 20,
           autoHeight: true,
          },
          {
            headerName: 'Description',
            field: 'description',
            minWidth: 150,
            //maxWidth: 150,
           autoHeight: true,
          },
          {
            headerName: 'Action',
            field: 'childGridRenderer',
            cellRenderer: CustomDetailComponentComponent,
            width: 20,
          //  autoHeight: true,
          },
        ],
        defaultColDef: { flex: 1 },
        context: {
          componentParent: this,
        },
      },
      getDetailRowData: this.childGridLoad.bind(this),
      getRowHeight: () => 'auto',
        };

    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
    this.refreshData();
    this.safetyDropDownData();
    this.selectedTab = this.const_aet
    this.highlightSafety = true;
    this.filterApiCall();
    this.thirtyDaysAgo.setDate((new Date()).getDate() - 30);
    this.startDateLine = this.thirtyDaysAgo.toISOString().substring(0, 10);
    this.regionFilterCtrl.valueChanges
    .pipe(
      
      startWith(''),
      map(search => search ? this.filterOption(search,this.dropdownRegionLine) : this.dropdownRegionLine?.slice())
    )
    .subscribe(filtered => {
      this.filteredRegion.next(filtered);
    });
    this.lpFilterCtrl.valueChanges
    .pipe(
      
      startWith(''),
      map(search => search ? this.filterOption(search,this.dropdownLpLine) : this.dropdownLpLine?.slice())
    )
    .subscribe(filtered => {
      this.filteredLp.next(filtered);
    });
    this.severityFilterCtrl.valueChanges
    .pipe(
      
      startWith(''),
      map(search => search ? this.filterOption(search,this.dropdownSeverityLine) : this.dropdownSeverityLine?.slice())
    )
    .subscribe(filtered => {
      this.filteredSeverity.next(filtered);
    });
  }
  private filterOption(search: string,list:any): any[] {
    const filterValue = search.toLowerCase();
    return list.filter(d => d.label.toLowerCase().includes(filterValue));
  }
  isAllSelected(option:any,list:any): boolean {
    return option?.length == list?.length; // NOSONAR
  }
  
 
  isIndeterminate(option:any,list:any): boolean {
    return option?.length > 0 &&
           list?.length > 0 &&
           option?.length < list?.length;
  }
  

  toggleSelectAll(event: any, optionKey: 'selectedRegionLine' | 'selectedLpLine' | 'selectedSeverityLine', list: any[]): void {
    if (!Array.isArray(list)) {
      return;
    }

    if (event.checked) {
      (this as any)[optionKey] = [...list];
    } else {
      (this as any)[optionKey] = [];
    }

    this.onTimeSpanChange();
  }
  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON.parse(roles);
    
    if (
      (userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
      userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
      userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
      userRoles.includes(this.constants.LIOS_UAC_General_User))
    ) {
      
      if (
        (userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
        userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
        userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
        userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
        userRoles.includes(this.constants.LIOS_UAC_AET_LP))
      ) {
        this.isAccessible = true;
        
      }
    } else {
      this.router.navigate([`/home`]);
    }
  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) { // NOSONAR
      return 0;
    }
    if (date1Number == null) { // NOSONAR
      return -1;
    }
    if (date2Number == null) { // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  async safetyDropDownData() {
    await this.aetSafetyDashboardService?.callingDropDowns().then((x) => {
      const dropdownPayload = this.extractDropdownPayload(x);

      if (dropdownPayload.lengthOfService && dropdownPayload.lengthOfService.length > 0) {
        this.losDrpDown = [];
        dropdownPayload.lengthOfService.forEach((element) => {
          this.losDrpDown.push({ label: element.id, value: element.sftyLenDesc });
        });
        this.losDrpDown = this.sortDropdownByValue(this.losDrpDown);
      }
      if (dropdownPayload.process && dropdownPayload.process.length > 0) {
        this.processDrpDown = [];
        dropdownPayload.process.forEach((element) => {
          this.processDrpDown.push({
            label: element.id,
            value: element.safetyProcessDesc,
            code: element.safetyProcessCode,
          });
        });
        this.processDrpDown = this.sortDropdownByValue(this.processDrpDown);
      }
      if (dropdownPayload.regionList && dropdownPayload.regionList.length > 0) {
        this.regionDrpDown = [];
        dropdownPayload.regionList.forEach((element) => {
          this.regionDrpDown.push({
            label: element.regionCode,
            value: element.regionDesc,
          });
        });
        this.regionDrpDown = this.sortDropdownByValue(this.regionDrpDown);
      }
      if (dropdownPayload.severity && dropdownPayload.severity.length > 0) {
        this.severityDrpDown = [];
        dropdownPayload.severity.forEach((element) => {
          this.severityDrpDown.push({
            label: element.id,
            value: element.safetyServCode,
          });
        });
        this.severityDrpDown = this.sortDropdownByValue(this.severityDrpDown);
      }

      if (dropdownPayload.tmTitle && dropdownPayload.tmTitle.length > 0) {
        this.tmTitleDrpDown = [];
        dropdownPayload.tmTitle.forEach((element) => {
          this.tmTitleDrpDown.push({
            label: element.id,
            value: element.safetyTitleDesc,
          });
        });
        this.tmTitleDrpDown = this.sortDropdownByValue(this.tmTitleDrpDown);
      }
      if (dropdownPayload.vendorList && dropdownPayload.vendorList.length > 0) {
        this.vendorDrpDown = [];
        dropdownPayload.vendorList.forEach((element) => {
          this.vendorDrpDown.push({
            label: element.vendorId,
            value: element.vendorCode,
          });
        });
        this.vendorDrpDown = this.sortDropdownByValue(this.vendorDrpDown);
      }

      this.dropdownRegionLine = this.regionDrpDown || [];
      this.dropdownSeverityLine = this.severityDrpDown || [];
      this.dropdownLpLine = this.vendorDrpDown || [];
      this.selectedRegionLine = [...this.dropdownRegionLine];
      this.selectedSeverityLine = [...this.dropdownSeverityLine];
      this.selectedLpLine = [...this.dropdownLpLine];
      this.filteredRegion.next(this.dropdownRegionLine.slice());
      this.filteredSeverity.next(this.dropdownSeverityLine.slice());
      this.filteredLp.next(this.dropdownLpLine.slice());
    });
  }

  private extractDropdownPayload(response: any): any {
    const payload = response?.event ?? response;
    if (Array.isArray(payload)) {
      return this.mapCriteriaFiltersResponse(payload);
    }
    return {
      ...payload,
      regionList: this.normalizeRegionList(payload?.regionList),
      severity: this.normalizeSeverityList(payload?.severity),
      vendorList: this.normalizeVendorList(payload?.vendorList),
      tmTitle: this.normalizeSimpleList(payload?.tmTitle, 'safetyTitleDesc'),
      process: this.normalizeSimpleList(payload?.process, 'safetyProcessDesc', 'safetyProcessCode'),
      lengthOfService: this.normalizeSimpleList(payload?.lengthOfService, 'sftyLenDesc'),
    };
  }

  private normalizeSimpleList(list: any, descKey: string, codeKey: string = 'id'): any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((item: any) => ({
      ...item,
      id: item?.id ?? item?.itemCode ?? item?.code ?? '',
      [descKey]: item?.[descKey] ?? item?.itemDesc ?? item?.name ?? item?.label ?? '',
      [codeKey]: item?.[codeKey] ?? item?.itemCode ?? item?.code ?? '',
    }));
  }

  private normalizeRegionList(list: any): any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((item: any) => ({
      ...item,
      regionCode: item?.regionCode ?? item?.itemCode ?? item?.code ?? '',
      regionDesc: item?.regionDesc ?? item?.itemDesc ?? item?.name ?? item?.label ?? '',
    }));
  }

  private normalizeSeverityList(list: any): any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((item: any) => ({
      ...item,
      id: item?.id ?? item?.itemCode ?? item?.code ?? '',
      safetyServCode: item?.safetyServCode ?? item?.itemCode ?? item?.code ?? item?.itemDesc ?? '',
      safetyServDesc: item?.safetyServDesc ?? item?.itemDesc ?? item?.name ?? item?.label ?? '',
    }));
  }

  private normalizeVendorList(list: any): any[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((item: any) => ({
      ...item,
      vendorId: item?.vendorId ?? item?.id ?? item?.vendorCode ?? '',
      vendorCode: item?.vendorCode ?? item?.shortName ?? item?.name ?? item?.itemCode ?? '',
      vendorName: item?.vendorName ?? item?.name ?? item?.vendorCode ?? '',
    }));
  }

  private mapCriteriaFiltersResponse(filters: any[]): any {
    const findFilter = (keywords: string[]): any =>
      filters.find((filter: any) => {
        const label = (filter?.label ?? '').toString().toLowerCase();
        return keywords.some((keyword) => label.includes(keyword));
      });

    const toSimple = (filter: any, descKey: string): any[] => {
      const values = filter?.values ?? {};
      return Object.entries(values).map(([key, value]) => ({
        id: key,
        [descKey]: (value ?? key)?.toString(),
      }));
    };

    const toRegion = (filter: any): any[] => {
      const values = filter?.values ?? {};
      return Object.entries(values).map(([key, value]) => ({
        regionCode: key,
        regionDesc: (value ?? key)?.toString(),
      }));
    };

    const toVendor = (filter: any): any[] => {
      const values = filter?.values ?? {};
      return Object.entries(values).map(([key, value]) => ({
        vendorId: key,
        vendorCode: (value ?? key)?.toString(),
        vendorName: (value ?? key)?.toString(),
      }));
    };

    return {
      regionList: toRegion(findFilter(['region'])),
      severity: toSimple(findFilter(['severity']), 'safetyServCode'),
      vendorList: toVendor(findFilter(['logistic', 'lp', 'partner'])),
      tmTitle: toSimple(findFilter(['t/m', 'tm title', 'title', 'team member']), 'safetyTitleDesc'),
      process: toSimple(findFilter(['process']), 'safetyProcessDesc'),
      lengthOfService: toSimple(findFilter(['length of service', 'length', 'service']), 'sftyLenDesc'),
    };
  }

  private sortDropdownByValue<T extends { value?: string }>(list: T[]): T[] {
    if (!Array.isArray(list)) {
      return [];
    }
    return [...list].sort((a, b) =>
      (a?.value ?? '').toString().localeCompare((b?.value ?? '').toString(), undefined, { sensitivity: 'base' })
    );
  }

  openChild(id, safetyEventId) {
    const dialogRef = this.dialog.open(ChildGridComponent, {
      disableClose: true,
      width: '1010px',
      height: '225px',
      data: {
        header: `Report No. ${id}`,
        safetyEventId: safetyEventId,
        event: 'child',
        tmTitleDrpDown: this.tmTitleDrpDown,
        losDrpDown: this.losDrpDown,
        processDrpDown: this.processDrpDown,
      },
    });
    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result?.event == 'triedToDelete') {// NOSONAR
        if (result?.result == 'success') {// NOSONAR
          this.refreshData();
          this.successMessage = 'Successfully Deleted';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, this.constants.notificationMessageTime );
        } else if (result?.result == 'failure') {// NOSONAR
          this.refreshData();
          this.errorMessage = 'Unable to delete';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }

  closeEvent(id) {
    const dialogRef = this.dialog.open(CloseEventComponent, {
      disableClose: true,
      width: '570px',
      height: '185px',
      data: {
        header: `Close Event No. ${id}`,
        event: 'close',
        id: id,
        description:
          'Are you sure you want to close event - closing event will result in further changes unable to be made  ',
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);

      if (result?.event == 'SaveEvent') {// NOSONAR
        if (result?.data == 'success') { // NOSONAR
          this.refreshData();
          this.successMessage = 'eventClosed';
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, 5000);
        } else if (result?.data == 'failure') { // NOSONAR
          this.errorMessage = 'error occured';
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, 5000);
        } else {
          this.errorMessage = result?.data;
          setTimeout(() => {
            this.successMessage = null;
            this.errorMessage = null;
          }, 5000);
        }
      }
    });
  }

  imagePopUp(body) {
    const dialogRef = this.dialog.open(ImagePopUpComponent, {
      disableClose: true,
      width: '570px',
      height: '520px',
      data: {
        data: body,
        header: 'Image Upload Section',
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.refreshData();
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result?.event == 'SaveEvent') { // NOSONAR
        if (result?.data == 'Success') { // NOSONAR
          this.successMessage = ''; 
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 5000); //this.constants.notificationMessageTime);
        }
      }
    });
  }

  childGridLoad(params: any) {
    this.errorMessage = null;
    this.successMessage = null;
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    const requestbody = { safetyEventId: params.data.safetyEventId };
    this.aetSafetyDashboardService?.childGridCall(requestbody)?.subscribe(
      (response) => {
        this.childData = response;
        const keys = ['ecg', 'lsa', 'sop', 'swf', 'tm'];
        const uniqueRows = this.childData.reduce((result, obj) => {
          const existingObj = result.find(
            (item) => item.reportId == obj.reportId // NOSONAR
          );

          if (!existingObj) {
            result.push(obj);
          } else {
            for (const key in obj) {
              if (keys.includes(key)) {
                if (obj[key] == 4) { // NOSONAR
                  existingObj[key] = obj[key];
                }
              }
            }
          }

          return result;
        }, []);
        params.successCallback(uniqueRows);
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.errorMessage = null;
          this.successMessage = null;
        }, 5000);
      }
    );
  }

  auto() {
    this.autoPress = !this.autoPress;
    if (!this.autoPress) {this.stopLoop();}
    this.intervalSubscription = interval(this.selected_position_id)
      .pipe(takeWhile(() => this.componentIsActive()))
      .subscribe(() => {
        this.refreshData();
      });
  }

  private componentIsActive(): boolean {
    if (this.autoPress) {return true;}
    return false;
  }

  stopLoop() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }

  dateFormatter(res) {
    if (res == null) {return '';} // NOSONAR
    else {return moment(res).format('MM/DD/YYYY HH:mm');}
  }

  safetyEdit(body) {
    const dialogRef = this.dialog.open(EditSafetyComponent, {
      disableClose: true,
      width: '1007px',
      height: '450px',
      data: {
        header: 'Edit Safety Event',
        data: body,
        vendorDrpDown: this.vendorDrpDown,
        severityDrpDown: this.severityDrpDown,
        regionDrpDown: this.regionDrpDown,
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result?.responseType == 'success') { // NOSONAR
          this.refreshData();
          this.successMessage = 'AET safety Event updated successfully.';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 5000);
        } else {
          this.errorMessage = 'AET safety Event update failed.';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 5000);
        }
      }
      if (result.event == 'onDeletePress') {// NOSONAR
        this.deleteEvent(result.id);
      }
    });
  }

  finalSafetyEdit(body) {
    const dialogRef = this.dialog.open(FinalEditSafetyComponent, {
      disableClose: true,
      width: '1007px',
      height: '450px',
      data: {
        data: body,
        header: 'Edit Final Safety Event',
        tmTitleDrpDown: this.tmTitleDrpDown,
        losDrpDown: this.losDrpDown,
        processDrpDown: this.processDrpDown,
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result.event == 'onDeletePress') {// NOSONAR
        this.deleteEvent(result.id);
      }
    });
  }

  deleteEvent(id) {
    const dialogRef = this.dialog.open(CloseEventComponent, {
      disableClose: true,
      width: '570px',
      height: '217px',
      data: {
        header: `Delete Event No. ${id}`,
        event: 'delete',
        id: id,
        description: `Deleting this event will be permanent, and cannot be reversed.
          Are you sure you want to delete this event?`,
      },
    });

    dialogRef.afterClosed()?.subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (result?.event == 'SaveEvent') {// NOSONAR
        if (result?.data == 'success') {// NOSONAR
          this.refreshData();
          this.successMessage = 'Successfully Deleted';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, this.constants.notificationMessageTime );
        } else if (result?.data == 'failure') {// NOSONAR
          this.refreshData();
          this.errorMessage = 'Unable to delete';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }

  createEvent() {
    this.router?.navigate([`/safety-dashboard/create-event`]);
  }

  onGridSizeChanged(params: any) {
    params.api.sizeColumnsToFit();
  }
   onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if(this.rowCount == 0 && Number(check) == 0 ){// NOSONAR
      document.getElementById('lbCurrentPage').innerHTML='0';
    }
    }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  goToNexpage() {
    this.gridApi.paginationGoToNextPage();
  }
  goToPreviousPage() {
    this.gridApi.paginationGoToPreviousPage();
  }
  goToFirstPage() {
    this.gridApi.paginationGoToFirstPage();
  }
  goToLastPage() {
    this.gridApi.paginationGoToLastPage()
  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();

    if (this.currentPageNo == 0) {// NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage =
      Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {// NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText(
        '#lbCurrentPage',
        this.gridApi.paginationGetCurrentPage() + 1
      );
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == 'ALL') {// NOSONAR
      this.paginationPageSize = event.target.value;
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }

  generatingPdf(id) {
    this.aetSafetyDashboardService.generatingPdf(id)?.subscribe((response) => {
      if (response?.size >= 1) {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `AET-SafetyEvent-${id}.pdf`;
        link.click();
        URL.revokeObjectURL(url);
        link.remove();
      }
    });
  }

  reOpenEvent(id){
    const toyotaGUID = localStorage.getItem('toyotaGUID');
    this.successMessage = null;
    this.errorMessage = null;
    this.aetSafetyDashboardService.reopenEvent(id,toyotaGUID)?.subscribe(
      (response) => {
          this.refreshData();
          this.successMessage = response;
    },
    _error => {
      this.errorMessage = CommonConstant.reOpenFailure;
    });
  }

  refreshData() {
    this.errorMessage = null;
    this.successMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.context = {
      componentParent: this,
    };
    this.aetSafetyDashboardService.loadMasterGrid()?.subscribe(
      (response) => {
        this.displayRowData = response;
        const keys = [
          'am',
          'bu',
          'ecg',
          'fa',
          'fr',
          'hj',
          'ho',
          'ilj',
          'inj',
          'loh',
          'los',
          'lsa',
          'nht',
          'ot',
          'pd',
          'sop',
          'st',
          'swf',
          'tm',
        ];
        const uniqueRows = this.displayRowData.reduce((result, obj) => {
          const existingObj = result.find(
            (item) => item.reportId == obj.reportId // NOSONAR
          );

          if (!existingObj) {
            result.push(obj);
          } else {
            for (const key in obj) {
              if (keys.includes(key)) {
                if (obj[key] == 4) { // NOSONAR
                  existingObj[key] = obj[key];
                }
              }
            }
          }

          return result;
        }, []);

        this.displayRowData = Object.values(uniqueRows).map((item: any) => {
          return {
            ...item,
            incidentDate: this.dateFormatter(item.incidentDate),
            reportDate: this.dateFormatter(item.reportDate),
            lastUpdateDate: this.dateFormatter(item.lastUpdateDate),
            routeDate: this.dateFormatter(item.routeDate),
          };
        });

        this.gridApi.applyTransaction({ add: this.displayRowData }); 
        this.rowCount = this.displayRowData.length;

        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.errorMessage = null;
          this.successMessage = null;
        }, 5000);
      }
    );
  }

  //Code for KPI Line Chart
  safetyDashboard(){
    this.highlightSafety = true;
    this.highlightKPI = false;
    this.selectedTab = this.const_aet;
  }
  safetyKPI(){
    this.highlightSafety = false;
    this.highlightKPI = true;
    this.selectedTab = 'Safety Dashboard KPI';
    this.universalData = this.displayRowData
    this.onTimeSpanChange()
  }
 
  public excelStyles : ExcelStyle[] =[
      {
        id: 'header',
        interior:{
          color:'#b2b2b2',
          pattern: 'Solid',
        },
        font:{
          bold: true,
        },
      },
    ]
  onBtExport(){
    if(this.selectedTab == this.const_aet){ // NOSONAR
      const params = {
        columnKeys: [
          'reportId',
          'reportType',
          'region',
          'route',
          'severity',
          'logisticPointDescription',
          'incidentDate',
          'fa',
          'am',
          'loh',
          'fr',
          'inj',
          'ilj',
          'los',
          'hj',
          'ho',
          'nht',
          'bu',
          'st',
          'pd',
          'ot',
          'reportDate',
          'trailer',
          'incidentSummary',
          'status',
          'lastUpdateDate',
        ],
        fileName: 'AET-SafetyDashboard',
        sheetName: 'Data',
        columnWidth: 160,
      };
      this.gridApi.exportDataAsExcel(params);
    } else {
      const toyotaGUID = localStorage.getItem('toyotaGUID');
      this.ngxUiLoaderService.start(CommonConstant.loader);
      const inputBody = {
        startDate : this.datePipe.transform(this.startDateLine, this.const_year) + " 00:00:00",
        endDate : this.datePipe.transform(this.endDateLine, this.const_year) + " 23:59:59",
        region : this.selectedRegionLine?.map(x => x.label),
        lp : this.selectedLpLine?.map(x => x.value),
        severity : this.selectedSeverityLine?.map(x => x.value)
      }
      this.aetSafetyDashboardService.getExcel(toyotaGUID, inputBody)
      .subscribe({
        next:(response)=>{
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          const filename="AET-SafetyDashboard-"+ this.curDate
          const data: Blob = new Blob([(<any>response)?.body], { type: 'application/vnd.ms-excel' });
          FileSaver.saveAs(data, filename); 
        },
        error: ()=>{
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = this.constants.downloadError;
        }
      })
    }
  }
  public lineChartOptions: ChartOptions = {}
  callingLineChartOptions() {
    this.lineChartOptions = {
      responsive: true,
      elements: {
        line: {
          tension: 0,
        },
      },
      scales: {
        x: {
          ticks: {
            maxRotation: 40,
            minRotation: 0,
            color: 'rgba(0,0,0,1)',
            font: {
              size: 15,
            },
          },
          grid: {
            drawOnChartArea: true,
          },
        },
        y: {
          max: this.maxValue, // ✅ Move max outside ticks
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            font: {
              size: 15,
            },
          },
        },
      },
      layout: {
        padding: {
          right: 20,
        },
      },
    };
  }
  
  

  public lineChartType: ChartType = 'line';

  lineChartLabels = [];
  lineChartLabelsBinding =[];

  lineChartData: ChartDataset[] = [];

  resetLine(){
    this.endDateLine= new Date().toISOString().substring(0, 10);
    this.thirtyDaysAgo = new Date()
    this.thirtyDaysAgo.setDate((new Date()).getDate() - 30);
    this.startDateLine = this.thirtyDaysAgo.toISOString().substring(0, 10)
    this.selectedSpan = 'Daily'
    this.selectedRegionLine = this.dropdownRegionLine
    this.selectedLpLine = this.dropdownLpLine
    this.selectedSeverityLine = this.dropdownSeverityLine
    this.onTimeSpanChange()
  }

  filterApiCall() {
    this.aetSafetyDashboardService.getFilter()?.subscribe((res) => {
      const payload = this.extractDropdownPayload(res);
      if (payload) {
        this.event = payload;
        if (this.event.severity && this.event.severity.length > 0) {
          this.dropdownSeverityLine = [];
          this.event.severity.forEach((obj, _index) => {
            this.dropdownSeverityLine.push({
              label: obj.safetyServCode,
              value: obj.safetyServCode,
            });

          });
          this.dropdownSeverityLine = this.sortDropdownByValue(this.dropdownSeverityLine);
          this.filteredSeverity.next(this.dropdownSeverityLine?.slice());
        }
        this.selectedSeverityLine = this.dropdownSeverityLine;

        if (this.event.regionList && this.event.regionList.length > 0) {
          this.dropdownRegionLine = [];
          this.event.regionList.forEach((obj, _index) => {
            this.dropdownRegionLine.push({
              label: obj.regionCode,
              value: obj.regionDesc,
            });
          });
          this.dropdownRegionLine = this.sortDropdownByValue(this.dropdownRegionLine);
          this.filteredRegion.next(this.dropdownRegionLine?.slice());
        }
        this.selectedRegionLine = this.dropdownRegionLine;

        if (this.event.vendorList && this.event.vendorList.length > 0) {
          this.dropdownLpLine = [];
          this.event.vendorList.forEach((obj, _index) => {
            this.dropdownLpLine.push({
              label: obj.vendorName ?? obj.vendorId,
              value: obj.vendorCode,
            });

          });
          this.dropdownLpLine = this.sortDropdownByValue(this.dropdownLpLine);
          this.filteredLp.next(this.dropdownLpLine?.slice());
        }
        this.selectedLpLine = this.dropdownLpLine;
      }
    });
  }

  customSort(a: string, b: string): number {
    enum Priority {
      HIGH = 1,
      MEDIUM = 2,
      LOW = 3
    }
    return Priority[a] - Priority[b];
  }

  ultimateFilter(data){
    this.lineChartData = []
    let dataList = [];
    let severityData = [];
    this.maxValue = 0;
    this.selectedSeverityLine?.map(x => x.value).sort(this.customSort).forEach(element => {
      dataList = []
      severityData = data?.filter(item => item.severity ==  element)// NOSONAR
      if(this.selectedSpan == 'Daily'){ // NOSONAR
        for(let i= 0 ; i < this.lineChartLabels.length ; i++ ){
          dataList.push(severityData?.filter(x =>
           new Date(x.incidentDate?.substring(0,10)).getTime() == new Date(this.datePipe.transform(this.lineChartLabels[i], this.const_year)).getTime()  // NOSONAR
          ).length)
        }
      } else {
        for(let i= 0 ; i < this.lineChartLabels.length ; i++ ){
          if(i == 0 ){  // NOSONAR
            dataList.push(severityData?.filter(x =>
              new Date(x.incidentDate?.substring(0,10)).getTime() == new Date(this.datePipe.transform(this.lineChartLabels[i], this.const_year)).getTime()  // NOSONAR
             ).length)
          } else {
            dataList.push(severityData?.filter(x =>
             new Date(x.incidentDate?.substring(0,10)).getTime() <= new Date(this.datePipe.transform(this.lineChartLabels[i], this.const_year)).getTime() && 
             new Date(x.incidentDate?.substring(0,10)).getTime() > new Date(this.datePipe.transform(this.lineChartLabels[i-1], this.const_year)).getTime()
            ).length)
          }
        }
      }
     
      this.lineChartData.push({ data : dataList, label : element , fill: false})
      if(this.maxValue < Math.max(...dataList))
        {this.maxValue = Math.max(...dataList)}
    })
    this.maxValue = this.maxValue +1
    this.callingLineChartOptions()
  }
  onModelUpdated(){
    this.sizeToFit();
  }
  onTimeSpanChange(){
    this.lineChartLabels = [];
    this.lineChartLabelsBinding=[];
    if(this.selectedSpan == 'Daily'){  // NOSONAR
      this.lineChartLabels =  this.getDatesBetween(new Date(this.startDateLine),new Date(this.endDateLine))
      console.info('some')
      this.lineChartLabelsBinding=this.lineChartLabels ;
    } else if(this.selectedSpan == 'Weekly'){   // NOSONAR
      this.lineChartLabels = this.getWeeklyDatesBetween(new Date(this.startDateLine),new Date(this.endDateLine))
      this.lineChartLabelsBinding=this.lineChartLabels;
    } else if(this.selectedSpan == 'Monthly'){ // NOSONAR
      this.lineChartLabels = this.getMonthlyDatesBetween(new Date(this.startDateLine),new Date(this.endDateLine))
      for(let i=0;i<this.lineChartLabels.length;i++){
        const storeLabel = this.lineChartLabels[i];
        const label = this.datePipe.transform(storeLabel,'MMM-yy');
        this.lineChartLabelsBinding[i]=label;
      }
      if(this.lineChartLabelsBinding[0] == this.lineChartLabelsBinding[1]){  // NOSONAR
        this.lineChartLabelsBinding[0]="";
      }
    } else if(this.selectedSpan == 'Yearly'){  // NOSONAR
      this.lineChartLabels = this.getYearlyDatesWithMinTwo(new Date(this.startDateLine),new Date(this.endDateLine))
      this.lineChartLabelsBinding=this.lineChartLabels;
    } else {
      this.lineChartLabels = this.getDatesBetween(new Date(this.startDateLine),new Date(this.endDateLine))
      this.lineChartLabelsBinding=this.lineChartLabels;
    }

    this.ultimateFilter(this.universalData?.filter(item => new Date((item.incidentDate).substring(0,10)) >= new Date(this.datePipe.transform(this.startDateLine, this.const_year)) && 
    new Date((item.incidentDate).substring(0,10)) <= new Date(this.datePipe.transform(this.endDateLine, this.const_year)) && (this.selectedRegionLine?.map(x => x.label).includes(item.region)) 
    && (this.selectedSeverityLine?.map(x => x.value).includes(item.severity)) && (this.selectedLpLine?.map(x => x.value).includes(item.logisticPoint)) ))
  }

  getDatesBetween(startDate: Date, endDate: Date): string[] {
    const dateList: string[] = [];
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dateList.push(currentDate.toISOString().substring(0, 10));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateList?.map(dateString => this.formatDate(dateString));
  }

  getWeeklyDatesBetween(startDate: Date, endDate: Date): string[] {
    const dateList: string[] = [];
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dateList.push(currentDate.toISOString().substring(0, 10));
      currentDate.setDate(currentDate.getDate() + 7);
    }
    dateList.push(endDate.toISOString().substring(0, 10));
    return (Array.from(new Set(dateList))).map(dateString => this.formatDate(dateString));
  }

  getLastDayOfMonth(year: number, month: number): number {
    return new Date(year, month + 1, 0).getDate();
  }

  getMonthlyDatesBetween(startDate: Date, endDate: Date): string[] {
    const dateList: string[] = [];
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      if(currentDate.getMonth()!== endDate.getMonth()){
      dateList.push(currentDate.toISOString().substring(0, 10));
      }
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const lastDayOfMonth = this.getLastDayOfMonth(currentYear, currentMonth);
      currentDate.setDate(lastDayOfMonth + 1); 
    }
    dateList.push(endDate.toISOString().substring(0, 10));
    return (Array.from(new Set(dateList))).map(dateString => this.formatDate(dateString));
  }

  getYearlyDatesWithMinTwo(startDate: Date, endDate: Date): string[] {
    const dateList: string[] = [];
    const currentDate = new Date(startDate);
    dateList.push(currentDate.toISOString().substring(0, 10));
    let currentYear = currentDate.getFullYear();
    currentDate.setFullYear(currentYear + 1);
    while (currentDate < endDate) {
      dateList.push(currentDate.toISOString().substring(0, 10));
      const nextYear = currentYear + 1;
      currentDate.setFullYear(nextYear);
      currentYear = nextYear;
    }
    dateList.push(endDate.toISOString().substring(0, 10));
    return (Array.from(new Set(dateList)))?.map(dateString => this.formatDate(dateString));
  }

  formatDate(dateString: string): string {
    const [year, month, day] = dateString.split('-');
    const formattedDate = `${month?.padStart(2, '0')}/${day?.padStart(2, '0')}/${year}`;
    return formattedDate;
  }

}

function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 16) { // NOSONAR
    return null;
  }
  const minNumber = Number.parseInt(date.substring(14, 16));
  const hourNumber = Number.parseInt(date.substring(11, 13));

  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));

  return yearNumber * 100000000 + monthNumber * 1000000 + dayNumber * 10000 + hourNumber * 100 + minNumber;
}